import palette from '../palette';

export default {
  minHeight: 80,
  background: palette.headerBackground,
};
